var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeEventsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 282.4 278.9",
    style: {
      enableBackground: "new 0 0 282.4 278.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0.5 0,215.2 63.7,215.2 63.7,24.8 112.3,95.2 170.8,95.2 219.1,24.8 219.1,95.2 282.3,95.2 282.3,0 180.7,0  142,56.5 102.4,0 0,0.5  ",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.4,106.5 88,106.5 88,215.2 282.3,215.2 282.3,190.6 161.1,190.6 161.1,169.5 282.3,169.5 282.3,146.8  161.1,146.8 161.1,130.2 282.3,130.2 282.4,106.5  ",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.6,236H13.6v11.9h22.6v8.3H13.6v13.6h25v8.3H0v-50.5h37.6V236z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,264.9h0.3l10-37.3h14.1l-15.5,50.5H56.4l-15.5-50.5h14.5L65,264.9z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.9,236h-24v11.9h22.6v8.3h-22.6v13.6h25v8.3H94.3v-50.5h37.6V236z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.7,262.2h0.2v-34.6h12.4v50.5h-15.5l-16.6-35.3h-0.2v35.3h-12.4v-50.5h15.7L171.7,262.2z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.2,236h-14.7v42.1h-13.6V236h-14.7v-8.3h43V236z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,263.8c0,1.2,0.1,2.2,0.4,3.2c0.3,1,0.7,1.8,1.4,2.4c0.7,0.7,1.6,1.2,2.8,1.6c1.2,0.4,2.6,0.6,4.4,0.6 c2.1,0,3.9-0.5,5.6-1.5c1.7-1,2.5-2.6,2.5-4.7c0-1.1-0.2-2.1-0.6-2.9c-0.4-0.8-1.1-1.6-2-2.2c-0.9-0.7-2.2-1.3-3.7-1.8 c-1.5-0.5-3.4-1.1-5.7-1.7c-3-0.8-5.6-1.6-7.8-2.5c-2.2-0.9-4-1.9-5.5-3.1c-1.5-1.2-2.6-2.6-3.3-4.2c-0.7-1.6-1-3.4-1-5.5 c0-5,1.9-8.7,5.6-11.2c3.7-2.4,8.8-3.7,15.3-3.7c3,0,5.8,0.2,8.3,0.7c2.5,0.5,4.7,1.3,6.6,2.4c1.9,1.1,3.3,2.5,4.3,4.2 c1,1.7,1.6,3.8,1.6,6.2v1.4h-13c0-2.4-0.6-4.2-1.7-5.5c-1.1-1.3-3-1.9-5.7-1.9c-1.5,0-2.8,0.2-3.8,0.5c-1,0.3-1.8,0.8-2.4,1.3 c-0.6,0.5-1,1.2-1.2,1.9c-0.2,0.7-0.3,1.4-0.3,2.2c0,1.6,0.4,2.9,1.3,3.9c0.9,1.1,2.8,2,5.7,2.9l10.5,3.4c2.6,0.8,4.7,1.7,6.3,2.6 c1.6,0.9,2.9,1.9,3.9,3c1,1.1,1.7,2.2,2,3.5c0.4,1.3,0.6,2.7,0.6,4.2c0,5.3-2.1,9.2-6.2,11.6c-4.1,2.4-9.9,3.6-17.2,3.6 c-7.7,0-13.2-1.2-16.5-3.7c-3.3-2.5-4.9-6.1-4.9-10.7v-2H250V263.8z",
    fill: "#ffffff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeEventsLogo);
export default __webpack_public_path__ + "static/media/me-events-logo.d525543c898d858e7ea6eb9a58eb53fa.svg";
export { ForwardRef as ReactComponent };